<button class="icon-button" [attr.aria-label]="ariaLabel" (click)="handleOnClick()">
  <img [src]="'assets/svg/icon-' + icon + '.svg'" [alt]="ariaLabel" />
</button>
